<template lang="pug">
.vacancy__container.row-container
  .col-container.col-4
    h1.vacancy-title.vacancy__title {{ title }}
    p(v-html="subtitle").vacancy-subtitle.vacancy__subtitle

  .col-container.col-7.vacancy-list.vacancy__list
    ContentParser(:content="content")
  .col-container
    VacancyFooter(:formValue="footer_data")
</template>

<script setup>
import { useVacancyStore } from '~~/stores/vacancy'
import { storeToRefs } from 'pinia';

const vacancyStore = useVacancyStore()
await vacancyStore.setIndexPage()
const {title, content, subtitle, footer_data, meta, og} = storeToRefs(vacancyStore)

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>

<style lang="scss" scoped>
.vacancy {

  &__container {
    display: flex;
    justify-content: space-between;

    // @media (min-width: 1024px) and (max-width: 1279px) {
      // padding-left: 5vw;
      // padding-right: 5vw;
    // }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }

  &__title {
    color: $primary;
    font-size: 34px;
    margin-bottom: 25px;
  }

  &__subtitle {
    color: $primary;
    margin-bottom: 100px;

    @media (min-width: $breakpoint-large) {
      margin-bottom: 25px;
    }
  }

  &__list {
    width: 100%;
  }
}
</style>